import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { DropdownOptionsComponent } from './dropdown-options/dropdown-options.component';
import { FilterDropdownComponent } from './filter-dropdown.component';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		CwpNgFrameworkModule,
		GenericDirectivesModule
	],
	declarations: [FilterDropdownComponent, DropdownOptionsComponent],
	exports: [FilterDropdownComponent, DropdownOptionsComponent]
})
export class FilterDropdownModule { }
